<template>
  <main class="container">
    <div class="checkmark">
      <CheckmarkIcon class="icon" />
    </div>

    <h1 class="page-title" data-testid="page-title">Good news!</h1>

    <p>
      One of your housemates has done the hard work already and created an
      account for <strong class="bold-orange">{{ address }}.</strong>
    </p>

    <p class="bold-orange">
      To join this account simply click the button below and pop in your
      details.
    </p>

    <button class="btn btn--big" @click="joinButtonClicked">
      Join Account
    </button>
  </main>
</template>

<script>
import CheckmarkIcon from "@/assets/svg/check.svg";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "AccountAlreadyExists",
  props: {
    guid: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      address: "getCustomerAddressString",
    }),
  },
  methods: {
    ...mapMutations({
      resetState: "RESET_STATE",
    }),
    joinButtonClicked() {
      this.resetState();
      this.$router.push({
        path: "joining-tenant",
        query: {
          guid: this.guid,
        },
      });

      this.trackGoogleEvent("Click Join", "Create Account", "Join account");
      this.trackFacebookEvent("Click Join");
    },
  },
  created() {
    // ensure back btn is hidden
    this.$store.commit("HIDE_BACK_BTN");

    this.trackGoogleEvent(
      "Land on account already created page",
      "Create Account",
      "Account already created",
    );
    this.trackFacebookEvent("Land on account already created page");
  },
  components: {
    CheckmarkIcon,
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 80rem;
  text-align: center;
}

.checkmark {
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 50%;
  background-color: $brand-orange;
  width: 100px;
  height: 100px;
  margin: 0 auto $spacing-large auto;

  .icon {
    fill: white;
    width: 60px;
    height: 100px;
  }
}

.bold-orange {
  display: block;
  font-weight: bold;
  color: $brand-orange;
}
</style>
